const normalizeFlagsResponse = (flagsResponse)=>{
    if ('flags' in flagsResponse) {
        const featureFlags = getFlagValuesFromFlags(flagsResponse.flags);
        const featureFlagPayloads = getPayloadsFromFlags(flagsResponse.flags);
        return {
            ...flagsResponse,
            featureFlags,
            featureFlagPayloads
        };
    }
    {
        const featureFlags = flagsResponse.featureFlags ?? {};
        const featureFlagPayloads = Object.fromEntries(Object.entries(flagsResponse.featureFlagPayloads || {}).map(([k, v])=>[
                k,
                parsePayload(v)
            ]));
        const flags = Object.fromEntries(Object.entries(featureFlags).map(([key, value])=>[
                key,
                getFlagDetailFromFlagAndPayload(key, value, featureFlagPayloads[key])
            ]));
        return {
            ...flagsResponse,
            featureFlags,
            featureFlagPayloads,
            flags
        };
    }
};
function getFlagDetailFromFlagAndPayload(key, value, payload) {
    return {
        key: key,
        enabled: 'string' == typeof value ? true : value,
        variant: 'string' == typeof value ? value : void 0,
        reason: void 0,
        metadata: {
            id: void 0,
            version: void 0,
            payload: payload ? JSON.stringify(payload) : void 0,
            description: void 0
        }
    };
}
const getFlagValuesFromFlags = (flags)=>Object.fromEntries(Object.entries(flags ?? {}).map(([key, detail])=>[
            key,
            getFeatureFlagValue(detail)
        ]).filter(([, value])=>void 0 !== value));
const getPayloadsFromFlags = (flags)=>{
    const safeFlags = flags ?? {};
    return Object.fromEntries(Object.keys(safeFlags).filter((flag)=>{
        const details = safeFlags[flag];
        return details.enabled && details.metadata && void 0 !== details.metadata.payload;
    }).map((flag)=>{
        const payload = safeFlags[flag].metadata?.payload;
        return [
            flag,
            payload ? parsePayload(payload) : void 0
        ];
    }));
};
const getFeatureFlagValue = (detail)=>void 0 === detail ? void 0 : detail.variant ?? detail.enabled;
const parsePayload = (response)=>{
    if ('string' != typeof response) return response;
    try {
        return JSON.parse(response);
    } catch  {
        return response;
    }
};
const createFlagsResponseFromFlagsAndPayloads = (featureFlags, featureFlagPayloads)=>{
    const allKeys = [
        ...new Set([
            ...Object.keys(featureFlags ?? {}),
            ...Object.keys(featureFlagPayloads ?? {})
        ])
    ];
    const flagValues = allKeys.filter((flag)=>featureFlags?.[flag] !== void 0 || !!featureFlagPayloads?.[flag]).reduce((res, key)=>(res[key] = featureFlags?.[key] ?? true, res), {});
    const flagDetails = {
        featureFlags: flagValues,
        featureFlagPayloads: featureFlagPayloads ?? {}
    };
    return normalizeFlagsResponse(flagDetails);
};
const updateFlagValue = (flag, value)=>({
        ...flag,
        enabled: getEnabledFromValue(value),
        variant: getVariantFromValue(value)
    });
function getEnabledFromValue(value) {
    return 'string' == typeof value ? true : value;
}
function getVariantFromValue(value) {
    return 'string' == typeof value ? value : void 0;
}
const flagDetailsToResults = (flagDetails)=>Object.values(flagDetails).map((detail)=>{
        const value = detail.variant ?? detail.enabled;
        const rawPayload = detail.metadata?.payload;
        return {
            key: detail.key,
            enabled: getEnabledFromValue(value),
            variant: getVariantFromValue(value),
            payload: void 0 !== rawPayload ? parsePayload(rawPayload) : null
        };
    });
const MINIMAL_FLAG_CALLED_EVENT_CAMPAIGN_PROPERTIES = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'gad_source',
    'mc_cid',
    'gclid',
    'gclsrc',
    'dclid',
    'gbraid',
    'wbraid',
    'fbclid',
    'msclkid',
    'twclid',
    'li_fat_id',
    'igshid',
    'ttclid',
    'rdt_cid',
    'epik',
    'qclid',
    'sccid',
    'oppref',
    'bfcid',
    'irclid',
    '_kx'
];
const MINIMAL_FLAG_CALLED_EVENT_PROPERTIES = [
    '$feature_flag',
    '$feature_flag_response',
    '$feature_flag_has_experiment',
    '$feature_flag_id',
    '$feature_flag_version',
    '$feature_flag_reason',
    '$feature_flag_request_id',
    '$feature_flag_evaluated_at',
    '$feature_flag_error',
    'locally_evaluated',
    '$groups',
    '$process_person_profile',
    '$geoip_disable',
    '$current_url',
    '$pathname',
    '$referring_domain',
    ...MINIMAL_FLAG_CALLED_EVENT_CAMPAIGN_PROPERTIES,
    '$session_id',
    '$window_id',
    '$lib',
    '$lib_version',
    '$device_id',
    '$is_server'
];
const minimizeFlagCalledEventProperties = (properties, transportKeys = [])=>{
    const minimal = {};
    const copyKey = (key)=>{
        if (void 0 !== properties[key]) minimal[key] = properties[key];
    };
    MINIMAL_FLAG_CALLED_EVENT_PROPERTIES.forEach(copyKey);
    transportKeys.forEach(copyKey);
    return minimal;
};
export { MINIMAL_FLAG_CALLED_EVENT_CAMPAIGN_PROPERTIES, MINIMAL_FLAG_CALLED_EVENT_PROPERTIES, createFlagsResponseFromFlagsAndPayloads, flagDetailsToResults, getEnabledFromValue, getFeatureFlagValue, getFlagValuesFromFlags, getPayloadsFromFlags, getVariantFromValue, minimizeFlagCalledEventProperties, normalizeFlagsResponse, parsePayload, updateFlagValue };
